import React, { useState } from 'react';
import { supabase } from '../services/supabase';

const EXPO_PUSH_URL = 'https://exp.host/--/api/v2/push/send';

const PUSH_TEMPLATES = [
  { icon: '🎯', label: 'Xal xatırlatması', title: 'Xal toplamağı unutmayın!', body: 'Cafegoo ilə hər ziyarətdə xal toplayın. Yetərli xalla dostunuza pulsuz kofe alın ☕' },
  { icon: '🎁', label: 'Pulsuz kofe', title: 'Pulsuz kofe qazanın!', body: 'Kifayət qədər xal topladınızsa, dostunuza pulsuz kofe sifariş edin 🎉' },
  { icon: '🔥', label: 'Xüsusi kampaniya', title: '🔥 Bu həftə xüsusi endirimlər!', body: 'Cafegoo tərəfdaş kafelərindən bu həftə xüsusi endirimlərdən yararlanın.' },
  { icon: '⭐', label: 'Yeni kafe', title: 'Yeni kafe əlavə edildi!', body: 'Sizin şəhərinizdə yeni kafe Cafegoo-da! İndi kəşf edin 🗺️' },
  { icon: '🏆', label: 'Liderlik', title: 'Xal liderlik cədvəli!', body: 'Bu ayın ən çox xal toplayan müştərilərini görün. Siz neçəncisiniz? 🏆' },
];

export default function NotificationsPage() {
  const [pushTitle, setPushTitle]     = useState('');
  const [pushBody, setPushBody]       = useState('');
  const [pushChannel, setPushChannel] = useState('campaigns');
  const [pushSending, setPushSending] = useState(false);
  const [pushResult, setPushResult]   = useState(null);
  const [tokenCount, setTokenCount]   = useState(null);

  const sendBroadcast = async () => {
    if (!pushTitle.trim() || !pushBody.trim()) return;
    setPushSending(true);
    setPushResult(null);
    try {
      const { data: tokens } = await supabase.from('push_tokens').select('token');
      const allTokens = (tokens || []).map(t => t.token).filter(Boolean);
      setTokenCount(allTokens.length);
      if (allTokens.length === 0) {
        setPushResult({ sent: 0, failed: 0, total: 0 });
        return;
      }
      const BATCH = 100;
      let sent = 0, failed = 0;
      for (let i = 0; i < allTokens.length; i += BATCH) {
        const batch = allTokens.slice(i, i + BATCH).map(token => ({
          to: token,
          title: pushTitle,
          body: pushBody,
          sound: 'default',
          channelId: pushChannel,
          priority: 'high',
        }));
        const res = await fetch(EXPO_PUSH_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(batch),
        });
        const json = await res.json();
        (json.data || []).forEach(r => {
          if (r.status === 'ok') sent++;
          else failed++;
        });
      }
      setPushResult({ sent, failed, total: allTokens.length });
    } catch (err) {
      setPushResult({ error: err.message });
    } finally {
      setPushSending(false);
    }
  };

  return (
    <div style={{ padding: 24, fontFamily: 'sans-serif', maxWidth: 900, margin: '0 auto' }}>
      <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1a1a2e', marginBottom: 4 }}>🔔 Push Bildirişlər</h1>
      <p style={{ color: '#888', fontSize: 13, marginBottom: 24 }}>
        Bütün istifadəçilərə push bildiriş göndərin.
        {tokenCount !== null && <span style={{ fontWeight: 700, color: '#FF6B35' }}> ({tokenCount} cihaz qeydiyyatdadır)</span>}
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {/* Templates */}
        <div style={{ background: '#fff', borderRadius: 16, padding: '20px 24px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <h3 style={{ margin: '0 0 14px', fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>Şablon Seçin</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
            {PUSH_TEMPLATES.map((t, i) => (
              <button key={i}
                onClick={() => { setPushTitle(t.title); setPushBody(t.body); }}
                style={{
                  padding: '8px 16px', borderRadius: 20, border: '1px solid #e0e0e0',
                  background: pushTitle === t.title ? '#FF6B35' : '#f9f9f9',
                  color: pushTitle === t.title ? '#fff' : '#333',
                  cursor: 'pointer', fontSize: 13, fontWeight: 600,
                }}>
                {t.icon} {t.label}
              </button>
            ))}
          </div>
        </div>

        {/* Compose */}
        <div style={{ background: '#fff', borderRadius: 16, padding: '20px 24px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>Bildiriş Yaz</h3>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, color: '#888', fontWeight: 600, display: 'block', marginBottom: 4 }}>Başlıq</label>
            <input
              value={pushTitle}
              onChange={e => setPushTitle(e.target.value)}
              placeholder="Bildiriş başlığı..."
              style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1.5px solid #e0e0e0',
                fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, color: '#888', fontWeight: 600, display: 'block', marginBottom: 4 }}>Mətn</label>
            <textarea
              value={pushBody}
              onChange={e => setPushBody(e.target.value)}
              placeholder="Bildiriş mətni..."
              rows={3}
              style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1.5px solid #e0e0e0',
                fontSize: 14, outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'sans-serif' }}
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, color: '#888', fontWeight: 600, display: 'block', marginBottom: 4 }}>Kanal</label>
            <select
              value={pushChannel}
              onChange={e => setPushChannel(e.target.value)}
              style={{ padding: '10px 14px', borderRadius: 10, border: '1.5px solid #e0e0e0', fontSize: 14, outline: 'none' }}>
              <option value="campaigns">Kampaniyalar</option>
              <option value="reminders">Xatırlatmalar</option>
              <option value="general">Ümumi</option>
            </select>
          </div>
          <button
            onClick={sendBroadcast}
            disabled={pushSending || !pushTitle.trim() || !pushBody.trim()}
            style={{
              padding: '12px 28px', borderRadius: 12, border: 'none',
              background: pushSending || !pushTitle.trim() || !pushBody.trim() ? '#bbb' : '#FF6B35',
              color: '#fff', fontWeight: 700, fontSize: 15, cursor: pushSending ? 'not-allowed' : 'pointer',
            }}>
            {pushSending ? 'Göndərilir...' : '🚀 Hamıya Göndər'}
          </button>
        </div>

        {/* Result */}
        {pushResult && (
          <div style={{
            background: pushResult.error ? '#FDEDEC' : '#E8F8F5',
            borderRadius: 14, padding: '16px 20px',
            color: pushResult.error ? '#e74c3c' : '#27ae60',
            fontWeight: 600, fontSize: 14,
          }}>
            {pushResult.error
              ? '❌ Xəta: ' + pushResult.error
              : `✅ Göndərildi: ${pushResult.sent} uğurlu, ${pushResult.failed} uğursuz (cəmi ${pushResult.total} cihaz)`
            }
          </div>
        )}
      </div>
    </div>
  );
}
